import { createFileRoute } from '@tanstack/react-router';
import { requirePendingPasswordChange } from '@web/core/auth/password-change';
import { AuthLayout } from '@web/modules/auth/auth-layout';
import { ChangePasswordPage } from '@web/modules/auth/change-password-page';

export interface ChangePasswordSearch {
  /** Where to go once the password is changed (checked by `safeNextPath`). */
  next?: string | undefined;
}

/**
 * The only screen of a session whose password is temporary (the API refuses everything
 * else). Outside the shell and outside `_auth` (that layout sends signed-in users away).
 */
export const Route = createFileRoute('/change-password')({
  validateSearch: (search: Record<string, unknown>): ChangePasswordSearch =>
    typeof search['next'] === 'string' ? { next: search['next'] } : {},
  beforeLoad: async ({ context, search }) => {
    await requirePendingPasswordChange(context.queryClient, search.next);
  },
  component: ChangePasswordRoute,
});

function ChangePasswordRoute() {
  const { next } = Route.useSearch();
  return (
    <AuthLayout>
      <ChangePasswordPage next={next} />
    </AuthLayout>
  );
}
